import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import translate from '@allesauto/i18n';
import { isWhiteLabel } from '@allesauto/utils/funcs.ts';
import Markdown from 'markdown-to-jsx';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { markdownProps } from '@/utils/markdown';

interface PrivacyNoticeProps {
  translationKey: string;
  privacyPolicyLink?: string;
  termsAndConditionsLink?: string;
  className?: string;
}

const PrivacyNotice: FC<React.PropsWithChildren<PrivacyNoticeProps>> = ({
  translationKey,
  className,
  privacyPolicyLink = '/pages/datenschutz',
  termsAndConditionsLink = '/allgemeine-geschaeftsbedingungen/',
}) => {
  const intl = useIntl();
  const whitelabel = useWhiteLabel();

  return (
    <Markdown className={className} {...markdownProps}>
      {translate(
        intl,
        isWhiteLabel(whitelabel)
          ? 'ui.FORMS.COMMON.PRIVACY_NOTICE.BASE_SENTENCE_WL'
          : 'ui.FORMS.COMMON.PRIVACY_NOTICE.BASE_SENTENCE',
        {
          subject: translate(intl, translationKey),
          privacyPolicyLink: whitelabel
            ? whitelabel?.dataPrivacyUrl
            : privacyPolicyLink,
          termsAndConditionsLink: whitelabel
            ? whitelabel?.termsAndConditionsUrl
            : termsAndConditionsLink,
        }
      )}
    </Markdown>
  );
};

export default PrivacyNotice;
